export default __webpack_public_path__ + "static/gold-leaf-d0dd588cc47d8b79ba1c882f76ad83fc.jpg";